import { render, staticRenderFns } from "./AppGoBackIcon.vue?vue&type=template&id=4e54e22e&"
import script from "./AppGoBackIcon.vue?vue&type=script&lang=js&"
export * from "./AppGoBackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports